import Fetch from './index'

export const getRDStationIntegration = async (assistantID) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/rd-station')
}

export const createRDStationIntegration = async (assistantID, body) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/rd-station/', {
    method: 'POST',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const deleteRDStationIntegration = async (assistantID, id) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/rd-station/' + id, {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
    },
  })
}

export const updateRDStationIntegration = async (assistantID, id, body) => {
  if (!assistantID) return Promise.reject('failed to read id')

  return Fetch('/assistant/' + assistantID + '/rd-station/' + id, {
    method: 'PUT',
    body: JSON.stringify(body),
    headers: {
      'Content-Type': 'application/json',
    },
  })
}
